export const assignedSegments: string[] = [
  'ParentBanner-BOTSON PLUS S.L. SOC.UNIPERSONAL',
  'Banner_C332_01',
  'Banner-TODO A UN EURO',
  'Banner_C1184_01',
  'Banner_C381_01',
  'Banner-NO OT C',
  'StoreGrade_CH02_09_01',
  'ParentBanner_C332',
  'ParentBanner-AGLA',
  'Banner-BOTSON PLUS S.L. SOC.UNIPERSONAL',
  'Banner_C1033_01',
  'Banner-AUTOSERVICIO EGUARAS PEPS',
  'Banner_C175_01',
  'Banner_C315_01',
  'ParentBanner-IGASA',
  'MarketSegment_CH03_02',
  'ParentBanner_C1348',
  'MarketSegment_CH04_03',
  'ParentBanner_C381',
  'Banner_C305_01',
  'ParentBanner-TERE FRUTOS SECOS',
  'ParentBanner-NTRA. SRA. SOLEDAD AUTOS',
  'Banner_C1311_01',
  'ParentBanner-QUICK FOODS',
  'Piloto_suggested_order',
  'ParentBanner_C097',
  'Banner_C1363_01',
  'ParentBanner-WPT',
  'Banner-SUPERCOR BARRIO',
  'ParentBanner_C092',
  'ParentBanner_C813',
  'ParentBanner_C834',
  'DM_NielsenSegmentBev_Bronce',
  'Comunicacion_Caducidad_Puntos_22',
  'StoreGrade_CH01_04_01',
  'StoreGrade_CH01_02_01',
  'ParentBanner_',
  'ParentBanner_C210',
  'ParentBanner-COLONIAS STA INES',
  'ParentBanner_C1168',
  'Banner_C809_01',
  'ParentBanner_C386',
  'DM_NielsenSegmentFood_Plata',
  'ParentBanner_C1353',
  'Banner-JOYFRANHU SL',
  'ParentBanner-LAS PLANCHAS 2',
  'StoreGrade_CH04_04_05',
  'ParentBanner_C955',
  'Banner-CHIP Y CHOP ALIMENTACIÃ“N',
  'ParentBanner_C387',
  'Banner-BP CODO 2.0',
  'CEDO-NOBAR',
  'StoreGrade_CH04_07_02',
  'DM_PepSegmentBev_C',
  'ParentBanner-SUPER PRECIOS H AND JURAD',
  'DO-NOBAR',
  'StoreGrade_CH02_06_01',
  'PROMO_JUN_BEB',
  'Banner-AVANZA OIL',
  'Banner-DESAVIO DE ANITA 24H',
  'ParentBanner_C057',
  'Banner_C1201_01',
  'StoreGrade_CH02_06_02',
  'layer-bronce',
  'tt-a-b',
  'Banner_C136_01',
  'Banner_C1353_01',
  'Banner_C795_01',
  'MarketSegment_CH04_07',
  'StoreGrade_CH01_06_01',
  'Banner_C1192_01',
  'ParentBanner-HELADOS ALIMENTACION',
  'Banner-D-PIS F-S GABRIEL',
  'Banner-ALIDROMUR',
  'Banner-EUREST COLECTIVIDADES S.R.L + COMPASS',
  'ParentBanner_C1359',
  'Banner-DESHORAS',
  'ParentBanner-CHIP Y CHOP ALIMENTACIÃ“N',
  'Banner_C062_01',
  'ParentBanner_C1421',
  'ParentBanner-CARNICERIAS IBAGAR SL',
  'PepSegmentFood_D',
  'DM_NielsenSegmentFood_Oro',
  'ParentBanner-RADIMA',
  'ParentBanner_C1338',
  'CEDO',
  'StoreGrade_CH04_04_02',
  'StoreGrade_CH05_06_01',
  'StoreGrade_CH02_02_01',
  'Banner_C645_01',
  'Banner_C1358_01',
  'ParentBanner-BLUE BAY',
  'ParentBanner-SUPERMERCADOS CUEVAS',
  'DM_PepSegmentNut_',
  'Banner-CASA REMIGIO  ASOCIADOS',
  'Banner_C979_02',
  'ParentBanner-CASUAL FOODS & BEER',
  'MarketSegment_CH02_06',
  'ParentBanner_C207',
  'Banner-MUSART',
  'ParentBanner-ALFIZAN',
  'MarketSegment_CH02_02',
  'ParentBanner-DISTRIBUIDORES BARES SPAIN',
  'Banner_C159_07',
  'Banner-TIENDAS ANTICRISIS ALICANTE',
  'Banner_C152_01',
  'Banner_C822_01',
  'Banner_C1338_01',
  'Banner-EL PALACIO DE LA GOLOSI',
  'StoreGrade_CH03_02_01',
  'Banner_C1354_01',
  'MarketSegment_CH05_01',
  'StoreGrade_CH02_01_01',
  'MarketSegment_CH02_09',
  'ParentBanner_C1316',
  'CARGA_BEB_PROMO',
  'ParentBanner_C152',
  'Banner_C092_01',
  'ParentBanner-CLICK AND GO',
  'MarketSegment_CH01_10',
  'Banner_C1340_01',
  'free_hit_2',
  'DM_ChannelH4_BAR',
  'Banner-CARNICERIAS IBAGAR SL',
  'Banner-MONJOS SUPERMERCATS',
  'DM_NielsenSegmentBev_',
  'DM_PepSegmentFood_D',
  'ParentBanner-LA VITORIANA DE LA ALIMENTACIO',
  'Banner_C1344_01',
  'NielsenSegmentFood_Bronze',
  'Banner_C223_01',
  'ParentBanner_C139',
  'Banner-EL NUEVO DESAVIO MINIMARK',
  'PepSegmentFood_A',
  'Banner_C1135_01',
  'Banner_C1185_01',
  'ParentBanner-EUREST COLECTIVIDADES S.R.L + COMPASS',
  'MarketSegment_CH04_04',
  'MarketSegment_CH02_08',
  'Banner-CHEN ESQUINA ALIMENTACI',
  'Banner_C060_02',
  'Banner-QUICK FOODS',
  'ParentBanner-COARVAL COOP V',
  'BEBIDAS_CON_DS',
  'Banner_C060_03',
  'StoreGrade_CH04_04_03',
  'Banner_C1187_01',
  'ParentBanner_C645',
  'ParentBanner_C234',
  'MarketSegment_CH05_05',
  'Banner-CCVK FABRICA',
  'ParentBanner-EL NUEVO DESAVIO MINIMARK',
  'Banner-GRUPO HOTELES PLAYA SA',
  'ParentBanner_C1318',
  'StoreGrade_CH02_08_02',
  'DM_NielsenSegmentNut-Plata',
  'INTRO_BEB_PROMO',
  'Banner-ASIF SUPER.',
  'Banner_C1316_01',
  'ParentBanner_C1337',
  'ParentBanner_C1207',
  'DM_PepSegmentFood_B',
  'MarketSegment_CH01_02',
  'MarketSegment_ND',
  'Banner-LÃDER ALIMENT (DIEXALSA)',
  'StoreGrade_CH02_09_02',
  'DM_PepSegmentFood_',
  'Banner_C1203_01',
  'Banner-ASC',
  'Banner_C197_01',
  'ParentBanner-JOYFRANHU SL',
  'DM_PepSegmentFood_A',
  'ParentBanner_C309',
  'SOUTH',
  'ParentBanner-ALEJANDRO FRUTERIA',
  'NielsenSegmentBev_Bronze',
  'ParentBanner_C175',
  'Banner_C139_01',
  'Banner-LA TIENDECITA',
  'ParentBanner_C014',
  'Banner-CONSUM',
  'Banner-DISTRIBUIDORES BARES SPAIN',
  'Banner_C380_01',
  'Banner-GLOVO',
  'PepSegmentFood_B',
  'StoreGrade_CH01_09_01',
  'DO',
  'DM_NielsenSegmentBev_Plata',
  'Banner-IGASA',
  'StoreGrade_CH05_01_01',
  'Banner-LAS PLANCHAS 2',
  'ParentBanner-MUSART',
  'ParentBanner_C1363',
  'ParentBanner-AVANZA OIL',
  'Banner_C207_01',
  'Banner-LA VITORIANA DE LA ALIMENTACIO',
  'DM_PepSegmentBev_B',
  'ParentBanner_C227',
  'Banner_C387_01',
  'ParentBanner_C1352',
  'Banner-OPEN SHOP DURANGO SL',
  'ParentBanner-CCVK FABRICA',
  'ParentBanner_C822',
  'NielsenSegmentBev_Gold',
  'MarketSegment_CH04_05',
  'Banner-ESTANCOS MADRID',
  'Banner-WPT',
  'Banner_C126_01',
  'ParentBanner-D PISTACHO FRAN',
  'Banner-IVSIVERICA (DAVSA)',
  'Banner_C849_01',
  'Banner_C089_01',
  'Banner_C659_01',
  'NORTH',
  'ChannelH4_BA',
  'StoreGrade_CH01_10_02',
  'MarketSegment_CH01_09',
  'Banner-ALEJANDRO FRUTERIA',
  'Banner_C1352_01',
  'Banner-AGLA',
  'ParentBanner_C747',
  'DM_NielsenSegmentFood_Bronce',
  'ParentBanner-GLOVO',
  'Banner-FROIZ',
  'Banner-CASUAL FOODS & BEER',
  'ParentBanner_C1185',
  'ParentBanner_C134',
  'Banner_C1319_01',
  'Banner_C097_01',
  'ParentBanner-AUTOSERVICIO EGUARAS PEPS',
  'Banner-ALIMENTACION BAZAR',
  'layer-oro',
  'Banner_C349_01',
  'Banner-CAPRABO',
  'StoreGrade_CH04_02_01',
  'MarketSegment_CH01_06',
  'Banner-EAT OUT',
  'Banner-LA PARADA ALIMENTACION',
  'ParentBanner_C659',
  'MarketSegment_CH05_06',
  'MarketSegment_CH01_08',
  'ParentBanner_C1033',
  'Banner_C1348_01',
  'ParentBanner-PIERRE VACANCES',
  'Banner-LA CALETA F-S',
  'DM_PepSegmentBev_',
  'ParentBanner-CASH Â & CARRY FENGSHUI',
  'ParentBanner_C1376',
  'Banner_C234_01',
  'StoreGrade_CH04_04_04',
  'MarketSegment_CH02_04',
  'Banner_C159_01',
  'ParentBanner-IVSIVERICA (DAVSA)',
  'MarketSegment_CH06_04',
  'StoreGrade_CH04_01_01',
  'Banner-MOYA SAUS',
  'ParentBanner_C126',
  'ParentBanner-MONJOS SUPERMERCATS',
  'Banner_C127_01',
  'DM_NielsenSegmentBev_Oro',
  'MarketSegment_CH06_03',
  'Banner-CASA REMIGIO PROPIOS',
  'ParentBanner-LA MAMMA',
  'Banner_C834_01',
  'ParentBanner-LA TIENDECITA',
  'Banner-GASOLINERA MLC',
  'ParentBanner-OPEN SHOP DURANGO SL',
  'Banner-COMASA DI',
  'StoreGrade_CH04_07_01',
  'Banner-NTRA. SRA. SOLEDAD AUTOS',
  'ParentBanner_C136',
  'ParentBanner_C368',
  'Banner_C1349_01',
  'Banner_C210_03',
  'ParentBanner-JUAN FORNÃˆS',
  'ParentBanner_C1192',
  'ParentBanner_C1201',
  'StoreGrade_CH03_01_03',
  'Banner-EL BOTELLON',
  'Banner-LA MAMMA',
  'MarketSegment_CH01_07',
  'MarketSegment_CH03_01',
  'FormatoTurista',
  'Banner_C014_01',
  'ParentBanner-CASA REMIGIO',
  'ParentBanner_C1349',
  'Banner-SUPERMERCADOS CUEVAS',
  'Banner_C299_01',
  'ParentBanner_C086',
  'ParentBanner-COMASA DI',
  'Banner-CASH Â & CARRY FENGSHUI',
  'Banner_C1318_01',
  'Banner-BLUE BAY',
  'ParentBanner_C060',
  'ParentBanner_C809',
  'ParentBanner_C1203',
  'ParentBanner-ZSHOP',
  'Banner_C386_01',
  'Banner-WONEST',
  'ParentBanner_C795',
  'DM_NielsenSegmentFood_',
  'PROMO_BAR_JUN22_SMALL_35',
  'ParentBanner_C1342',
  'ParentBanner_C1311',
  'ParentBanner-DON PISTACHO 2 FRUTOS SEC',
  'ParentBanner_ND',
  'Banner_C1528_01',
  'ParentBanner_C127',
  'Banner_C1261_01',
  'ParentBanner-GRUPO SETOR',
  'Bebidas_por_interno',
  'Banner_C1359_01',
  'ParentBanner-ASIF SUPER.',
  'ParentBanner-LA PARADA ALIMENTACION',
  'StoreGrade_CH02_09_03',
  'ParentBanner-TIENDAS ANTICRISIS ALICANTE',
  'ParentBanner-ALIMENTACION BAZAR',
  'ParentBanner-NO OT T',
  'Banner-DON PISTACHO 2 FRUTOS SEC',
  'Banner-CHUCHES MANGAS FRUTOS S',
  'Banner_C634_02',
  'ParentBanner_C380',
  'Banner_C747_01',
  'StoreGrade_CH03_01_05',
  'ParentBanner_C1138',
  'ParentBanner_C299',
  'StoreGrade_CH03_01_04',
  'layer-plata',
  'ParentBanner-DESHORAS',
  'NielsenSegmentFood_Gold',
  'StoreGrade_ND',
  'ParentBanner-ALIDROMUR',
  'ParentBanner_C1340',
  'Banner_C955_01',
  'ParentBanner_C223',
  'ParentBanner-MIRABENI',
  'Banner_C368_01',
  'Banner_C1337_01',
  'NielsenSegmentBev_Silver',
  'Banner-JUAN FORNÃ‰S',
  'DM_PepSegmentFood_C',
  'Banner_C207_02',
  'Cluster_Food_1',
  'StoreGrade_CH01_08_01',
  'Banner-ALFIZAN',
  'PepSegmentFood_C',
  'StoreGrade_CH06_03_01',
  'StoreGrade-TERRESTRE',
  'ParentBanner_C1135',
  'StoreGrade_CH02_03_01',
  'ParentBanner-NO OT C',
  'Banner-ILEVEL CATERING',
  'ParentBanner_C1102',
  'StoreGrade_CH01_07_01',
  'Banner-CLICK AND GO',
  'Banner_C309_01',
  'all_disctricts_ex_north_south',
  'MarketSegment_CH02_03',
  'ParentBanner_C305',
  'ParentBanner-EAT OUT',
  'Banner-CUDAL SL',
  'Banner_C1182_01',
  'StoreGrade_CH02_04_01',
  'ParentBanner_C1166',
  'MarketSegment_CH01_04',
  'Banner_C1332_01',
  'ParentBanner-SUPER ESPARTERO',
  'ParentBanner-ASC',
  'so-smoketest-p8-2024',
  'Banner-TERE FRUTOS SECOS',
  'Banner-EL PASO 1 SUPERMERCADOS',
  'Banner_C1364_01',
  'ParentBanner_C1187',
  'ParentBanner-DESAVIO DE ANITA 24H',
  'ParentBanner-WONEST',
  'ParentBanner_C1332',
  'StoreGrade_CH04_04_01',
  'ParentBanner_C1364',
  'ParentBanner-CONSUM',
  'MarketSegment_CH04_02',
  'DM_ChannelH4_Retail',
  'Banner-RADIMA',
  'ParentBanner_C349',
  'ParentBanner_C849',
  'ParentBanner-MOYA SAUS',
  'ParentBanner-TU SUPER',
  'Banner-HELADOS ALIMENTACION',
  'FormatoSinPvp',
  'Banner_ND',
  'Banner_C1042_01',
  'Banner_C086_02',
  'Banner_C1362_02',
  'ParentBanner_C159',
  'Banner-FLASH IN A RUSH',
  'ParentBanner-ILEVEL CATERING',
  'ParentBanner-CHUCHES MANGAS FRUTOS S',
  'ParentBanner-HIPER MANACOR',
  'ParentBanner-LA CALETA F-S',
  'ParentBanner_C979',
  'ParentBanner-GALIPAN',
  'Banner_C1166_01',
  'ParentBanner_C1261',
  'DM_NielsenSegmentNut_',
  'Banner-HIPER MANACOR',
  'NielsenSegmentFood_Silver',
  'StoreGrade_CH04_05_01',
  'ParentBanner-EL BOTELLON',
  'ParentBanner_C089',
  'ParentBanner-GASOLINERA MLC',
  'Free_Hit',
  'StoreGrade_CH01_10_01',
  'StoreGrade_CH04_06_01',
  'Banner-ZSHOP',
  'DO-BAR',
  'Banner_C1342_01',
  'Banner_C1207_01',
  'ParentBanner-GRUPO HOTELES PLAYA SA',
  'Banner_C1421_01',
  'ParentBanner-GOLOSINAS DANVAL',
  'ParentBanner_C062',
  'Banner_',
  'Banner-GRUPO SETOR',
  'Banner_C1376_01',
  'ParentBanner_C1319',
  'ParentBanner_C1362',
  'ParentBanner_C197',
  'Banner-TU SUPER',
  'ParentBanner_C1528',
  'esp_freehit_discount_70members',
  'MarketSegment_CH02_01',
  'StoreGrade_CH06_04_01',
  'ParentBanner-CARO RUIZ SA',
  'ParentBanner_C1182',
  'ParentBanner-EL PASO 1 SUPERMERCADOS',
  'StoreGrade_CH04_03_01',
  'Welcome_Points',
  'DM_PepSegmentFood-A+',
  'ParentBanner-D-PIS F-S GABRIEL',
  'Banner-COARVAL COOP V',
  'ParentBanner-CHEN ESQUINA ALIMENTACI',
  'Banner-SUPER ESPARTERO',
  'Banner-CARO RUIZ SA',
  'Banner_C813_01',
  'ParentBanner-CONDIS',
  'Banner-D PISTACHO FRAN',
  'MarketSegment_CH04_06',
  'ParentBanner-ESTANCOS MADRID',
  'MarketSegment-TRANSPORTE',
  'ParentBanner_C315',
  'CEDO-BAR',
  'Banner-NO OT T',
  'Banner-SUPER PRECIOS H AND JURAD',
  'Banner-GOLOSINAS DANVAL',
  'Banner-GALIPAN',
  'DM_ChannelH4_NOBAR',
  'ParentBanner-EL PALACIO DE LA GOLOSI',
  'ParentBanner-FLASH IN A RUSH',
  'StoreGrade_CH02_06_03',
  'ParentBanner_C1358',
  'Banner_C057_01',
  'Banner_C134_01',
  'ParentBanner_C1344',
  'Banner-CONDIS',
  'ParentBanner-FROIZ',
  'StoreGrade_CH02_08_03',
  'ParentBanner-LÃDER ALIMENT (DIEXALSA)',
  'DEVELOP_BEB_PROMO',
  'StoreGrade_CH03_01_02',
  'MarketSegment_CH04_01',
  'StoreGrade_CH05_05_01',
  'ParentBanner_C634',
  'Banner-COLONIAS STA INES',
  'ParentBanner_C1184',
  'Banner-PIERRE VACANCES',
  'ChannelH4_NB',
  'StoreGrade_CH02_09_04',
  'ParentBanner-TODO A UN EURO',
  'Banner_C1168_01',
  'Marratxi_DC',
  'StoreGrade_CH03_01_01',
  'ParentBanner-CUDAL SL',
  'DM_ChannelH4_TT',
  'Banner_C1102_01',
  'Banner_C1138_01',
  'ParentBanner_C1042',
  'Banner_C227_01',
  'PROMO_BAR_JUN22_BIG_50',
  'Banner-MIRABENI',
  'ParentBanner_C1354',
]
